// Auto-loads any images present in src/assets/projects, keyed by filename
// without extension. Files that aren't there yet simply don't appear, so the
// build never breaks on a missing photo — callers fall back to a placeholder.
// Recursive so photos can be organised in subfolders; keyed by bare filename.
const ctx = require.context("@/assets/projects", true, /\.(jpe?g|png|webp)$/i);

const local = {};
ctx.keys().forEach((key) => {
  const name = key
    .replace(/^\.\//, "")
    .replace(/^.*\//, "") // drop any directory prefix
    .replace(/\.(jpe?g|png|webp)$/i, "");
  local[name] = ctx(key);
});

/** Resolve a local project photo by filename (without extension). */
export function img(name, fallback) {
  if (!local[name] && !fallback) {
    // Loud in dev, harmless in prod — a typo'd name shouldn't fail silently.
    console.warn(`[projectImages] no image named "${name}" in src/assets/projects`);
  }
  return local[name] || fallback;
}

/** True once the real photo has been dropped into src/assets/projects. */
export function hasImg(name) {
  return Boolean(local[name]);
}

export default local;
